export enum PdfStatus {
  GENERATED = "generated",
  QUEUED = "queued",
  ERROR = "error",
}
